module.exports = __webpack_public_path__ + "images/emoji/no_entry.8519bec5b3e685249f8c.png";